import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  API_COBOT_INFERENCE_URL,
  API_COBOT_URL,
} from 'src/app/core/providers/constants/api.constants';
import { ItemCobotPreview } from '../types/cobot-item-preview';
import { ItemCobot } from '../../view-cobot-item/types/item-cobot';
import { CobotFilters } from '../types/cobot-filters';
import { SearchFiltersCobot } from '../types/search-filters-cobot';
import { CobotCamFilters } from '../types/cobot-cam-filters';
import { ParamsCobotCamPreview } from '../types/params-cobot-cam-preview';
import { ItemCobotCamPreview } from '../types/cobot-cam-preview';
import { CobotCavityFilters } from '../types/cobot-cavity-filters';
import { ParamsCobotCavityPreview } from '../types/params-cobot-cavity-preview';
import { ItemCobotCavityPreview } from '../types/cobot-cavity-preview';
import { ImageAddGroundTruth } from '../types/images-add-ground-truth';
import { PayloadUpdateCam } from '../types/payload-update-cam';
import { CobotUpdateManuallyCams } from '../types/cobot-update-manually-cams';
import { ItemCobotUpdate } from '../types/update-cobot.dto';

@Injectable({
  providedIn: 'root',
})
export class APIRouteCompressionViewCobotItemService {
  constructor(private readonly http: HttpClient) {}

  private baseUrl = `${API_COBOT_URL}`;
  private inferenceBaseUrl = `${API_COBOT_INFERENCE_URL}`;

  predictSegmentation(image: Blob): Observable<Blob> {
    return this.http.post(`${this.inferenceBaseUrl}/seg/predict`, image, {
      headers: { 'Content-Type': 'image/png' },
      responseType: 'blob',
      withCredentials: true,
    });
  }

  predictSegmentationFromUrl(
    imageUrl: string,
    cam: string,
    position: string,
    precision: 'fp16' | 'fp8' = 'fp16'
  ): Observable<Blob> {
    return this.http.post(
      `${this.inferenceBaseUrl}/seg/predict-url`,
      { imageUrl, cam, position, precision },
      {
        responseType: 'blob',
        withCredentials: true,
      }
    );
  }

  getLatestRunsAvailable(body: {
    hasInspectionId: boolean;
  }): Observable<ItemCobot[]> {
    // Query params
    let params = new HttpParams();

    params = params.append('hasInspectionId', body.hasInspectionId);

    return this.http.get<ItemCobot[]>(`${this.baseUrl}/latest-runs-available`, {
      params,
      withCredentials: true,
    });
  }

  updateItemsCobot(body: ItemCobotUpdate) {
    return this.http.put<ItemCobot[]>(`${this.baseUrl}/runs/update`, body, {
      withCredentials: true,
    });
  }

  updateInspection(body: CobotUpdateManuallyCams): Observable<ItemCobot> {
    return this.http.put<ItemCobot>(`${this.baseUrl}/update/inspection`, body, {
      withCredentials: true,
    });
  }

  setCamMeanwhile(body: PayloadUpdateCam): Observable<{
    message: string;
  }> {
    return this.http.put<{
      message: string;
    }>(`${this.baseUrl}/set-cam/meanwhile`, body, {
      withCredentials: true,
    });
  }

  addImagesToGroundTruth(body: ImageAddGroundTruth): Observable<{
    message: string;
  }> {
    return this.http.put<{
      message: string;
    }>(`${this.baseUrl}/add/images/ground-truth`, body, {
      withCredentials: true,
    });
  }

  getPreviewCobotItems(
    searchFiltersCobot?: SearchFiltersCobot
  ): Observable<ItemCobotPreview[]> {
    let params = new HttpParams();

    if (searchFiltersCobot?.runId) {
      params = params.append('runId', searchFiltersCobot.runId);
    }
    if (searchFiltersCobot?.cavity) {
      params = params.append('cavity', searchFiltersCobot.cavity);
    }
    // if (searchFiltersCobot?.cam) {
    //   params = params.append('cam', searchFiltersCobot.cam);
    // }
    if (searchFiltersCobot?.machine) {
      params = params.append('machine', searchFiltersCobot.machine);
    }
    if (searchFiltersCobot?.assemblyItem) {
      params = params.append('assemblyItem', searchFiltersCobot.assemblyItem);
    }
    if (searchFiltersCobot?.orderBy) {
      params = params.append('orderBy', searchFiltersCobot.orderBy);
    }
    if (searchFiltersCobot?.dateStart) {
      params = params.append('dateStart', searchFiltersCobot.dateStart);
    }
    if (searchFiltersCobot?.dateEnd) {
      params = params.append('dateEnd', searchFiltersCobot.dateEnd);
    }
    if (searchFiltersCobot?.take) {
      params = params.append('take', searchFiltersCobot.take);
    }

    if (searchFiltersCobot?.conditionPiece) {
      params = params.append(
        'conditionPiece',
        searchFiltersCobot?.conditionPiece
      );
    }
    if (
      searchFiltersCobot?.cavityHasError !== undefined &&
      searchFiltersCobot?.cavityHasError !== null
    ) {
      params = params.append(
        'cavityHasError',
        searchFiltersCobot?.cavityHasError
      );
    }

    return this.http.get<ItemCobotPreview[]>(`${this.baseUrl}/items/preview`, {
      params,
      withCredentials: true,
    });
  }

  getCobotItems(
    searchFiltersCobot?: SearchFiltersCobot
  ): Observable<ItemCobot[]> {
    let params = new HttpParams();

    if (searchFiltersCobot?.runId) {
      params = params.append('runId', searchFiltersCobot.runId);
    }
    // if (searchFiltersCobot?.cavity) {
    //   params = params.append('cavity', searchFiltersCobot.cavity);
    // }
    // if (searchFiltersCobot?.cavityIn && searchFiltersCobot.cavityIn.length > 0) {
    //   params = params.append('cavityIn', searchFiltersCobot.cavityIn.join(','));
    // }
    // if (searchFiltersCobot?.cam) {
    //   params = params.append('cam', searchFiltersCobot.cam);
    // }
    if (searchFiltersCobot?.machine) {
      params = params.append('machine', searchFiltersCobot.machine);
    }
    if (searchFiltersCobot?.assemblyItem) {
      params = params.append('assemblyItem', searchFiltersCobot.assemblyItem);
    }
    if (searchFiltersCobot?.orderBy) {
      params = params.append('orderBy', searchFiltersCobot.orderBy);
    }
    if (searchFiltersCobot?.dateStart) {
      params = params.append('dateStart', searchFiltersCobot.dateStart);
    }
    if (searchFiltersCobot?.dateEnd) {
      params = params.append('dateEnd', searchFiltersCobot.dateEnd);
    }
    if (searchFiltersCobot?.take) {
      params = params.append('take', searchFiltersCobot.take);
    }

    if (searchFiltersCobot?.skip) {
      params = params.append('skip', searchFiltersCobot.skip);
    }

    return this.http.get<ItemCobot[]>(`${this.baseUrl}/items`, {
      params,
      withCredentials: true,
    });
  }

  getCobotItem(id: string | number): Observable<ItemCobot> {
    return this.http.get<ItemCobot>(`${this.baseUrl}/item/${id}`, {
      withCredentials: true,
    });
  }

  getCobotItemsByRunIds(runIds: number[]): Observable<ItemCobot[]> {
    return this.http.post<ItemCobot[]>(
      `${this.baseUrl}/items/runs`,
      {
        runIds,
      },
      {
        withCredentials: true,
      }
    );
  }

  getCobotCamPreview(
    params: ParamsCobotCamPreview
  ): Observable<ItemCobotCamPreview[]> {
    let paramsUrl = new HttpParams();

    if (params?.cavity) {
      paramsUrl = paramsUrl.append('cavity', params.cavity);
    }
    if (params?.cam) {
      paramsUrl = paramsUrl.append('cam', params.cam);
    }
    if (params?.stateCam) {
      paramsUrl = paramsUrl.append('stateCam', params.stateCam);
    }
    if (params?.dateStart) {
      paramsUrl = paramsUrl.append('dateStart', params.dateStart.toISOString());
    }
    if (params?.dateEnd) {
      paramsUrl = paramsUrl.append('dateEnd', params.dateEnd.toISOString());
    }
    if (params?.orderBy) {
      paramsUrl = paramsUrl.append('orderBy', params.orderBy);
    }
    if (params?.take) {
      paramsUrl = paramsUrl.append('take', params.take);
    }
    if (params?.position) {
      paramsUrl = paramsUrl.append('position', params.position);
    }
    if (params?.skip) {
      paramsUrl = paramsUrl.append('skip', params.skip);
    }

    return this.http.get<ItemCobotCamPreview[]>(`${this.baseUrl}/items/cams`, {
      params: paramsUrl,
      withCredentials: true,
    });
  }

  getCobotCavityPreview(
    params: ParamsCobotCavityPreview
  ): Observable<ItemCobotCavityPreview[]> {
    let paramsUrl = new HttpParams();
    if (params?.runId) {
      paramsUrl = paramsUrl.append('runId', params.runId);
    }
    if (params?.cavity) {
      paramsUrl = paramsUrl.append('cavity', params.cavity);
    }
    if (params?.hasError) {
      paramsUrl = paramsUrl.append('hasError', params.hasError);
    }
    if (params?.dateStart) {
      paramsUrl = paramsUrl.append('dateStart', params.dateStart.toISOString());
    }
    if (params?.dateEnd) {
      paramsUrl = paramsUrl.append('dateEnd', params.dateEnd.toISOString());
    }
    if (params?.orderBy) {
      paramsUrl = paramsUrl.append('orderBy', params.orderBy);
    }
    if (params?.machine) {
      paramsUrl = paramsUrl.append('machine', params.machine);
    }
    if (params?.assembly) {
      paramsUrl = paramsUrl.append('assembly', params.assembly);
    }
    if (params?.take) {
      paramsUrl = paramsUrl.append('take', params.take);
    }
    if (params?.skip) {
      paramsUrl = paramsUrl.append('skip', params.skip);
    }

    return this.http.get<ItemCobotCavityPreview[]>(
      `${this.baseUrl}/items/cavities`,
      {
        params: paramsUrl,
        withCredentials: true,
      }
    );
  }

  getCobotFilters(): Observable<CobotFilters> {
    return this.http.get<CobotFilters>(`${this.baseUrl}/filters/all`, {
      withCredentials: true,
    });
  }

  getCobotCamFilters(): Observable<CobotCamFilters> {
    return this.http.get<CobotCamFilters>(`${this.baseUrl}/cams/filters/all`, {
      withCredentials: true,
    });
  }

  getCobotCavityFilters(): Observable<CobotCavityFilters> {
    return this.http.get<CobotCavityFilters>(
      `${this.baseUrl}/cavities/filters/all`,
      {
        withCredentials: true,
      }
    );
  }
}
